'use client'

import React, { useEffect, useState } from 'react'
import { ModalDesktop, ModalMobile } from '@acko-tech/building-blocks.ui.modal'
import ModalContent from './ModalContent'

const CommsModal = ({ isModalOpen, handleModalOpen, content, isMobile }) => {
  const [isSubmitted, setIsSubmitted] = useState(false)

  const onHide = () => {
    handleModalOpen(false)
    setIsSubmitted(false)
  }

  const isPhoneModal = content?.commsCtas?.some(cta => cta.Type === 'Phone')

  useEffect(() => {
    document.documentElement.style.overflowY = isModalOpen ? 'hidden' : 'scroll'
  }, [isModalOpen])

  const renderModalContent = () => <ModalContent isMobile={isMobile} content={content} />

  return isMobile ? (
    <ModalMobile
      align="left"
      show={isModalOpen && !isSubmitted}
      onHide={onHide}
      padding="0px"
      urlhash=""
      showOverlayBackground
      disableOverlayClose={false}
      bodyMargin="0px"
      closeButtonStyles={{
        right: '20px',
        top: '20px',
        backgroundColor: '#0A0A0A0F',
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        maxWidth: '32px !important',
        maxHeight: '32px !important',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px',
      }}>
      {renderModalContent()}
    </ModalMobile>
  ) : (
    <ModalDesktop
      align="right"
      show={isModalOpen && !isSubmitted}
      onHide={onHide}
      padding="0px"
      urlhash=""
      disableOverlayClose={false}
      styles={
        isPhoneModal
          ? {
              width: '544px',
              borderRadius: '32px',
              overflow: 'hidden',
              ':nth-child(2)': {
                marginTop: '0px',
              },
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
            }
          : {
              width: '535px',
              borderRadius: '32px',
              overflow: 'hidden',
              ':nth-child(2)': {
                marginTop: '0px',
              },
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
            }
      }
      closeButtonStyles={{
        right: '26px',
        top: '24px',
        backgroundColor: '#7C7C7C66',
        width: '32px',
        height: '32px',
        maxWidth: '32px !important',
        maxHeight: '32px !important',
        borderRadius: '50%',
        svg: {
          filter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(262deg) brightness(108%) contrast(101%)',
        },
        padding: '4px',
      }}>
      {renderModalContent()}
    </ModalDesktop>
  )
}

export default CommsModal
